"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

require("./ToggleButton.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = function _default(_ref) {
  var value = _ref.value,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "toggle-button"
  }, options.map(function (x) {
    var isDisabled = x ? x.disabled : false;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: x.value || 'undefined',
      className: "toggle-button-option ".concat(value === x.value ? 'active' : '').concat(isDisabled ? 'disabled' : ''),
      onClick: function onClick() {
        return !isDisabled ? onChange({
          value: x.value
        }) : null;
      }
    }, x.title);
  }));
};

exports["default"] = _default;